/* ==========================================================================
   Binowee enquiry
   Vanilla JS, no framework, no bundler. Progressive enhancement: with JS off
   the product page still renders price, specification and a contact path, and
   the enquiry triggers are links to the contact page.

   Responsibilities
     1. The enquiry list, persisted per browser so a multi product enquiry
        survives navigation between product pages. Add, remove, quantity and a
        header count badge.
     2. The modal: focus trap, Escape, scroll lock, focus restore.
     3. Submission to the Shopify App Proxy, with an idempotency reference,
        a timing check and a mailto fallback when the endpoint is unreachable.

   Every customer facing string comes from the locale file through data
   attributes on #bw-enquiry-form. Nothing is hard coded here.

   No HubSpot credential exists in this file or anywhere in the theme. The
   proxy forwards to the middleware that holds it.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'binowee.enquiry.list.v1';
  var MIN_SECONDS = 3;
  var MAX_QTY = 9999;

  /* ---------------------------------------------------------- storage */
  /* Per viewer, per browser. Wrapped because a private window or blocked
     site data throws rather than returning null. */
  function readList() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }
  function writeList(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    paintCount(list);
    renderListPage(list);
  }
  function qtyOf(i) {
    var n = parseInt(i.quantity, 10);
    return n > 0 ? Math.min(n, MAX_QTY) : 1;
  }
  function lineKey(i) { return i.sku || i.url || i.title; }

  function paintCount(list) {
    var n = list.reduce(function (t, i) { return t + qtyOf(i); }, 0);
    document.querySelectorAll('[data-bw-enquiry-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-bw-enquiry-list-empty]').forEach(function (el) { el.hidden = n > 0; });
    document.querySelectorAll('[data-bw-enquiry-list-has]').forEach(function (el) { el.hidden = n === 0; });
  }

  function addToList(item) {
    var list = readList();
    var found = list.filter(function (i) { return lineKey(i) === lineKey(item); })[0];
    if (found) { found.quantity = Math.min(qtyOf(found) + 1, MAX_QTY); }
    else { list.push(item); }
    writeList(list);
    return list;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------------------------------------------- strings (i18n) */
  var form = document.getElementById('bw-enquiry-form');
  function t(key, fallback) {
    return (form && form.dataset[key]) || fallback || '';
  }

  /* --------------------------------------------------- enquiry list page */
  function renderListPage(list) {
    var host = document.getElementById('bw-enquiry-list-items');
    if (!host) return;
    host.innerHTML = list.map(function (i) {
      var k = escapeHtml(lineKey(i));
      var title = escapeHtml(i.title);
      return '<li class="bw-enquiry-row" data-bw-enquiry-row data-key="' + k + '">' +
        (i.image ? '<img src="' + escapeHtml(i.image) + '" alt="" loading="lazy" width="64" height="64">'
                 : '<span class="bw-enquiry-row__noimg" aria-hidden="true"></span>') +
        '<div class="bw-enquiry-row__body"><a href="' + escapeHtml(i.url) + '">' + title +
        (i.restriction ? '<sup class="bw-sale-flag" aria-hidden="true">*</sup>' : '') + '</a>' +
        (i.sku ? '<span class="bw-enquiry-row__sku">' + escapeHtml(i.sku) + '</span>' : '') +
        (i.restriction ? '<span class="bw-sale-note">* ' + escapeHtml(i.restriction) + '</span>' : '') + '</div>' +
        '<div class="bw-qty bw-qty--sm">' +
          '<button type="button" class="bw-qty__step" data-bw-list-step="-1" data-key="' + k + '" aria-label="' + escapeHtml(t('decrease', 'Decrease quantity')) + ', ' + title + '">&minus;</button>' +
          '<input class="bw-qty__input" type="number" min="1" max="' + MAX_QTY + '" inputmode="numeric" value="' + qtyOf(i) + '" data-bw-list-qty data-key="' + k + '" aria-label="' + escapeHtml(t('quantity', 'Quantity')) + ', ' + title + '">' +
          '<button type="button" class="bw-qty__step" data-bw-list-step="1" data-key="' + k + '" aria-label="' + escapeHtml(t('increase', 'Increase quantity')) + ', ' + title + '">+</button>' +
        '</div>' +
        '<button type="button" class="bw-enquiry-row__remove" data-bw-enquiry-remove="' + k + '">' +
          escapeHtml(t('remove', 'Remove')) + '<span class="visually-hidden"> ' + title + '</span></button>' +
        '</li>';
    }).join('');
  }
  function setQty(key, qty) {
    var list = readList();
    list.forEach(function (i) { if (lineKey(i) === key) i.quantity = Math.max(1, Math.min(qty, MAX_QTY)); });
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    paintCount(list);
  }

  /* ------------------------------------------------------------- modal */
  var modal = document.getElementById('bw-enquiry');
  var list0 = readList();
  paintCount(list0);
  renderListPage(list0);

  /* Triggers are links to the contact page in the markup, so they work with
     JS off. Once JS is running they open the modal instead. */
  document.querySelectorAll('[data-bw-enquire][href]').forEach(function (a) { a.setAttribute('role', 'button'); });

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-bw-enquiry-add]');
    if (addBtn) {
      e.preventDefault();
      addToList({
        title: addBtn.dataset.productTitle,
        sku: addBtn.dataset.productSku || '',
        url: addBtn.dataset.productUrl || '',
        image: addBtn.dataset.productImage || '',
        restriction: addBtn.dataset.productRestriction || '',
        quantity: 1
      });
      addBtn.classList.add('is-added');
      var status = addBtn.parentNode.querySelector('[data-bw-added-status]');
      if (status) { status.textContent = ''; status.textContent = t('added', 'Added to your enquiry list.'); }
      return;
    }

    var removeBtn = e.target.closest('[data-bw-enquiry-remove]');
    if (removeBtn) {
      e.preventDefault();
      var key = removeBtn.dataset.bwEnquiryRemove;
      writeList(readList().filter(function (i) { return lineKey(i) !== key; }));
      var heading = document.getElementById('bw-enquiry-list-title');
      if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus(); }
      return;
    }

    var listStep = e.target.closest('[data-bw-list-step]');
    if (listStep) {
      var input = listStep.parentNode.querySelector('[data-bw-list-qty]');
      var v = (parseInt(input.value, 10) || 1) + parseInt(listStep.dataset.bwListStep, 10);
      v = Math.max(1, Math.min(v, MAX_QTY));
      input.value = v;
      setQty(listStep.dataset.key, v);
      return;
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-bw-list-qty]');
    if (!input) return;
    var v = Math.max(1, Math.min(parseInt(input.value, 10) || 1, MAX_QTY));
    input.value = v;
    setQty(input.dataset.key, v);
  });

  if (!modal || !form) return;

  var result   = document.getElementById('bw-enquiry-result');
  var errorBox = document.getElementById('bw-enquiry-error');
  var linesBox = document.getElementById('bw-enquiry-lines');
  var submit   = document.getElementById('bw-enquiry-submit');
  var lastFocus = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([tabindex="-1"]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function currentLines() {
    var single = modal.dataset.singleTitle;
    if (single) {
      return [{ title: single, sku: modal.dataset.singleSku || '', url: modal.dataset.singleUrl || '', restriction: modal.dataset.singleRestriction || '', quantity: 1 }];
    }
    return readList().map(function (i) { return { title: i.title, sku: i.sku || '', url: i.url || '', restriction: i.restriction || '', quantity: qtyOf(i) }; });
  }

  /* Sale restriction (custom.sale_restriction, for example "Excluded for
     sale in W.A."). When the project state is WA, name the restricted lines
     before submit. Informs only: submission is never blocked. */
  var waBox = document.getElementById('bw-enquiry-wa');
  var stateField = document.getElementById('bw-enq-state');
  function paintWa() {
    if (!waBox || !stateField) return;
    var restricted = currentLines().filter(function (l) { return l.restriction; });
    if (stateField.value === 'WA' && restricted.length) {
      var names = restricted.map(function (l) { return l.title; }).join(', ');
      waBox.textContent = t('waNotice', 'Excluded for sale in W.A.: [products].').replace('[products]', names);
      waBox.hidden = false;
    } else {
      waBox.hidden = true;
      waBox.textContent = '';
    }
  }
  if (stateField) stateField.addEventListener('change', paintWa);

  function paintLines() {
    var lines = currentLines();
    if (!lines.length) { linesBox.hidden = true; linesBox.innerHTML = ''; return; }
    linesBox.hidden = false;
    linesBox.innerHTML = '<ul role="list">' + lines.map(function (l) {
      return '<li class="bw-line"><span>' + escapeHtml(l.title) +
             (l.restriction ? '<sup class="bw-sale-flag" aria-hidden="true">*</sup><span class="visually-hidden"> (' + escapeHtml(l.restriction) + ')</span>' : '') +
             (l.sku ? ' <span class="bw-line__sku">' + escapeHtml(l.sku) + '</span>' : '') +
             '</span><span class="bw-line__qty">' + escapeHtml(t('qtyPrefix', 'Qty')) + ' ' + l.quantity + '</span></li>';
    }).join('') + '</ul>';
  }

  function uuid() {
    if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    return 'bw-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  /* Spam layer 3: Cloudflare Turnstile, loaded only when the modal first
     opens so it costs nothing on page load. With no site key configured the
     widget is skipped entirely. */
  var tsHost = document.getElementById('bw-turnstile');
  var tsKey = tsHost && tsHost.dataset.sitekey;
  var tsWidget = null;
  var tsLoading = false;
  function renderTurnstile() {
    if (!tsKey || !window.turnstile) return;
    if (tsWidget !== null) { try { window.turnstile.reset(tsWidget); } catch (e) {} return; }
    tsWidget = window.turnstile.render(tsHost, { sitekey: tsKey, size: 'flexible', appearance: 'interaction-only' });
  }
  function loadTurnstile() {
    if (!tsKey) return;
    if (window.turnstile) { renderTurnstile(); return; }
    if (tsLoading) return;
    tsLoading = true;
    var sc = document.createElement('script');
    sc.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    sc.async = true;
    sc.onload = renderTurnstile;
    document.head.appendChild(sc);
  }
  function turnstileToken() {
    if (!tsKey) return '';
    try { return (window.turnstile && tsWidget !== null && window.turnstile.getResponse(tsWidget)) || ''; } catch (e) { return ''; }
  }

  function open(trigger) {
    lastFocus = trigger || document.activeElement;
    loadTurnstile();
    if (trigger && trigger.dataset.productTitle) {
      modal.dataset.singleTitle = trigger.dataset.productTitle;
      modal.dataset.singleSku   = trigger.dataset.productSku || '';
      modal.dataset.singleUrl   = trigger.dataset.productUrl || '';
      modal.dataset.singleRestriction = trigger.dataset.productRestriction || '';
    } else {
      delete modal.dataset.singleTitle;
      delete modal.dataset.singleSku;
      delete modal.dataset.singleUrl;
      delete modal.dataset.singleRestriction;
    }
    paintLines();
    paintWa();
    form.hidden = false;
    result.hidden = true;
    errorBox.hidden = true;
    document.getElementById('bw-enquiry-t').value = String(Date.now());
    document.getElementById('bw-enquiry-ref').value = uuid();
    document.getElementById('bw-enquiry-source').value = window.location.href;

    /* Lock the background without a layout shift: compensate for the
       scrollbar the lock removes. */
    var gap = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--bw-scrollbar', gap + 'px');
    document.body.classList.add('bw-locked');

    modal.hidden = false;
    var first = modal.querySelector('#bw-enq-firstname');
    if (first) first.focus();
  }

  /* Used by binowee-freight.js to hand a cart that cannot be quoted online
     over to an enquiry. */
  window.BinoweeEnquiry = {
    add: addToList,
    open: open,
    setNote: function (text) {
      var n = document.getElementById('bw-enq-notes');
      if (n && text && n.value.indexOf(text) === -1) n.value = n.value ? n.value + '\n' + text : text;
    }
  };

  function close() {
    modal.hidden = true;
    document.body.classList.remove('bw-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-bw-enquire]');
    if (openBtn) { e.preventDefault(); open(openBtn); return; }
    if (e.target.closest('[data-bw-close]')) { e.preventDefault(); close(); return; }
    if (e.target === modal) close();
  });

  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(modal.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* -------------------------------------------------------- submission */
  function fail(message, field) {
    errorBox.textContent = message;
    errorBox.hidden = false;
    if (field) {
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', 'bw-enquiry-error');
      field.focus();
    } else {
      errorBox.scrollIntoView({ block: 'nearest' });
    }
  }

  form.addEventListener('input', function (e) {
    if (e.target.getAttribute('aria-invalid')) {
      e.target.removeAttribute('aria-invalid');
      e.target.removeAttribute('aria-describedby');
    }
  });

  function showFallback(payload) {
    /* The endpoint is unreachable, or the spam check could not run. Never drop the submission silently:
       hand the customer a prefilled email instead. The address always
       resolves, because the section defaults it to the store email. */
    var to = form.dataset.fallbackEmail;
    var lines = payload.items.map(function (l) { return '- ' + l.title + (l.sku ? ' (' + l.sku + ')' : '') + ' x' + (l.quantity || 1); }).join('\n');
    var body = 'Name: ' + payload.contact.firstname + ' ' + payload.contact.lastname +
      '\nCompany: ' + payload.contact.company + '\nEmail: ' + payload.contact.email +
      '\nPhone: ' + payload.contact.phone + '\nProject: ' + payload.project.name +
      '\nLocation: ' + payload.project.location + ' ' + payload.project.state +
      '\nScale: ' + payload.project.scale + '\nDelivery window: ' + payload.project.delivery_window +
      '\n\nItems:\n' + lines + '\n\nNotes:\n' + payload.notes + '\n\nRef: ' + payload.ref;
    result.hidden = false;
    form.hidden = true;
    result.innerHTML = '<p class="bw-result bw-result--warn"><strong>' + escapeHtml(t('failTitle')) + '</strong><br>' +
      escapeHtml(t('failBody')) + '</p>' +
      '<a class="bw-btn" href="mailto:' + encodeURIComponent(to) + '?subject=' +
        encodeURIComponent(t('mailSubject') + ' ' + payload.ref.slice(0, 8).toUpperCase()) + '&body=' + encodeURIComponent(body) + '">' + escapeHtml(t('mailButton')) + '</a>';
    result.focus();
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorBox.hidden = true;

    var data = {};
    new FormData(form).forEach(function (v, k) { data[k] = typeof v === 'string' ? v.trim() : v; });

    if (data.hp) { close(); return; }                       /* honeypot: silent */
    var elapsed = (Date.now() - parseInt(data.t, 10)) / 1000;
    if (!(elapsed >= MIN_SECONDS)) { fail(t('errTooFast')); return; }
    if (!data.firstname) { fail(t('errName'), document.getElementById('bw-enq-firstname')); return; }
    if (!data.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) { fail(t('errEmail'), document.getElementById('bw-enq-email')); return; }
    if (!currentLines().length && !data.notes) { fail(t('errEmpty'), document.getElementById('bw-enq-notes')); return; }
    if (!document.getElementById('bw-enq-consent').checked) { fail(t('errConsent'), document.getElementById('bw-enq-consent')); return; }

    var payload = {
      ref: data.ref,
      contact: { firstname: data.firstname, lastname: data.lastname || '', email: data.email, phone: data.phone || '', company: data.company || '' },
      project: { name: data.project || '', location: data.location || '', state: data.state || '', delivery_window: data.window || '', scale: data.scale || '' },
      /* A restricted line on a WA project carries its restriction into the
         deal, so the quote starts from the right place. */
      items: currentLines().map(function (l) {
        var title = l.title;
        if (l.restriction && data.state === 'WA') title += ' (' + l.restriction + ')';
        return { title: title, sku: l.sku, url: l.url, quantity: l.quantity };
      }),
      notes: data.notes || '',
      consent: true,
      source_url: data.source_url,
      hp: '',
      t: data.t,
      turnstile: turnstileToken()
    };

    /* The verifier did not load (blocked script, strict network) or was not
       completed. Posting without a token would be dropped as spam, silently,
       so hand the customer the email route instead. */
    if (tsKey && !payload.turnstile) { form.hidden = true; showFallback(payload); return; }

    submit.disabled = true;
    submit.textContent = t('sending');

    var endpoint = form.dataset.endpoint || '/apps/enquiry';
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 12000);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Idempotency-Key': payload.ref },
      body: JSON.stringify(payload),
      signal: controller.signal
    })
      .then(function (r) { clearTimeout(timer); if (!r.ok) throw new Error('http ' + r.status); return r.json().catch(function () { return {}; }); })
      .then(function () {
        form.hidden = true;
        linesBox.hidden = true;
        result.hidden = false;
        result.innerHTML = '<p class="bw-result bw-result--ok"><strong>' + escapeHtml(t('okTitle')) + '</strong><br>' +
          escapeHtml(t('okBody')) + '</p><p class="bw-result__ref">' + escapeHtml(t('refLabel')) + ' ' + escapeHtml(payload.ref.slice(0, 8).toUpperCase()) + '</p>';
        result.focus();
        if (!modal.dataset.singleTitle) writeList([]);
        if (tsWidget !== null) { try { window.turnstile.reset(tsWidget); } catch (e) {} }
      })
      .catch(function () {
        clearTimeout(timer);
        showFallback(payload);
      })
      .then(function () {
        submit.disabled = false;
        submit.textContent = t('send');
      });
  });
})();
